import { computed, get } from '@ember/object';

export default function greaterThanProperty(dependentKey, targetKey) {
  return computed(dependentKey, targetKey, function () {
    return get(this, dependentKey) > get(this, targetKey);
  });
}
